import { FunctionComponent } from "react";
import { Tabs, TabsProps } from "antd";

interface TabsItemProps {
  title: string | JSX.Element;
  content: JSX.Element | JSX.Element[];
  officeId?: string;
}

interface BasicTabsProps extends TabsProps {
  tabs: TabsItemProps[];
  className?: string;
  onTabChange?: (officeId?: string) => void;
}

const BasicTabs: FunctionComponent<BasicTabsProps> = ({
  tabs,
  className = "",
  onTabChange,
  ...props
}) => {
  const items: TabsProps["items"] = tabs.map((tab, index) => ({
    key: `${index}`,
    label: tab.title,
    children: tab.content,
  }));

  const handleChange = (key: string) => {
    const selectedTab = tabs[parseInt(key)];
    if (onTabChange) {
      onTabChange(selectedTab?.officeId);
    }
  };

  return (
    <Tabs
      {...props}
      className={`app-tabs ${className}`}
      defaultActiveKey="0"
      centered={false}
      tabPosition="top"
      items={items}
      type="card"
      destroyInactiveTabPane
      onChange={handleChange}
      data-test="table-item"
    />
  );
};

export default BasicTabs;
